import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import Navbar from "../components/Navbar";
import { useLanguage } from "../i18n/LanguageContext";
import api from "../lib/api";

export default function ForgotPassword() {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, lang });
    } catch {}
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="forgot-password-page">
      <Navbar />
      <div className="mx-auto flex max-w-md flex-col px-4 py-16">
        <div className="rounded-md border-2 border-slate-900 bg-white p-8 shadow-[8px_8px_0px_0px_rgba(56,189,248,1)]">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border-2 border-slate-900 bg-green-100">
                <CheckCircle2 className="h-7 w-7 text-green-700" strokeWidth={2} />
              </span>
              <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-slate-900">{t("auth.forgotTitle")}</h1>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{t("auth.resetEmailSent")}</p>
              <Link to="/login" data-testid="back-to-login-link"
                className="mt-6 inline-flex items-center gap-2 rounded-full border-2 border-slate-900 bg-sky-400 px-6 py-2.5 font-heading text-sm font-bold text-slate-900 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-sky-500">
                <ArrowLeft className="h-4 w-4" strokeWidth={2.5} /> {t("auth.backToLogin")}
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">{t("auth.forgotTitle")}</h1>
              <p className="mt-1 text-sm text-slate-500">{t("auth.forgotSubtitle")}</p>
              <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="forgot-password-form">
                <div>
                  <label className="text-xs font-bold uppercase tracking-wider text-slate-600">{t("auth.email")}</label>
                  <div className="relative mt-1.5">
                    <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" strokeWidth={2} />
                    <input
                      type="email" required value={email}
                      data-testid="forgot-email-input"
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full rounded-md border-2 border-slate-900 bg-white py-2.5 pl-10 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
                    />
                  </div>
                </div>
                <button
                  type="submit" disabled={loading}
                  data-testid="forgot-submit-button"
                  className="flex w-full items-center justify-center gap-2 rounded-full border-2 border-slate-900 bg-sky-400 py-2.5 font-heading text-sm font-bold text-slate-900 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-sky-500 hover:shadow-[4px_4px_0px_0px_rgba(15,23,42,1)] disabled:opacity-60"
                >
                  {loading && <Loader2 className="h-4 w-4 animate-spin" />} {t("auth.sendResetLink")}
                </button>
              </form>
              <p className="mt-6 text-center text-sm text-slate-500">
                <Link to="/login" data-testid="forgot-back-to-login" className="font-bold text-sky-600 hover:underline">
                  {t("auth.backToLogin")}
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
